<template>
	<div id="Inventories" class="inventories">
		<div class="table-responsive" v-if="!loadingInventories">
			<table class="table table-sm table-hover">
				<thead>
					<tr>
						<th class="text-center">ID</th>
						<th>Descripción</th>
						<th class="text-center">Año</th>
						<th class="text-center">Fecha de Inventario</th>
						<th class="text-center">Estado</th>
						<th class="text-right">
							<i class="fas fa-plus margin-right5 pointer" title="Nuevo inventario" @click="newInventoryLocal" v-show="!newInventory"></i>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="newInventory">
						<td class="text-center">{{ objectInventory.id }}</td>
						<td><input v-model="objectInventory.description" type="text" class="input-default"></td>
						<td class="text-center"><input v-model="objectInventory.year" type="text" class="text-center input-default"></td>
						<td><input v-model="objectInventory.inventory_date" type="date" class="text-center input-default"></input></td>
						<td class="text-right">
							<i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveInventoryLocal()"></i>
							<i class="fas fa-minus-circle text-danger margin-right5 pointer" title="Nuevo inventario" @click="newInventory = !newInventory"></i>
						</td>
					</tr>
					<tr v-for="(item, index) in listInventories" :key="index">
						<td class="text-center">{{ item.id }}</td>
						<td>{{ item.description }}</td>
						<td class="text-center">{{ item.year }}</td>
						<td class="text-center">{{ item.inventory_date }}</td>
						<td class="text-center">{{ item.status.name }}</td>
						<td class="text-right">
							<router-link :to="'/inventory/' + item.id" class="far fa-eye pointer text-info"></router-link>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else class="text-center">
			Cargando inventarios...
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventories from '@/mixins/inventories'

	export default {
		name: 'Inventories',
		mixins: [axiosAction, errors, mixin, inventories],
		data() {
			return {
				newInventory: false
			}
		},
		computed: {
		},
		methods: {
			initComponenetLocal() {
				this.setTitleModule('Inventario')
				this.setSubTitleModule('')
				this.setComponentLocal()
			},
			getAllInventoriesResultLocal(response) {},
			newInventoryLocal() {
				this.clearObjectInventory()
				this.newInventory = true
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllInventoriesResult': this.getAllInventoriesResult(response); break;
					case 'saveInventoryResult': this.saveInventoryResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveInventoryLocal() {
				if(this.objectInventory.description.trim().length > 3 && this.objectInventory.year.trim().length > 0 && !isNaN(this.objectInventory.year.trim())) {
					this.saveInventory()
				} else {
					alert('Algo no corresponde en lo que ha ingresado')
				}
			},
			saveInventoryResultLocal(response) {
				if(response.data.success == true) {
					this.newInventory = false
					this.clearObjectInventory()
				} else {
					alert('Algo a salido mal y no se pudo guardar')
				}
			},
			setComponentLocal() {
				this.getAllInventories()
			},
		},
		components: {
		},
		mounted () {
			this.initComponenetLocal()
		}
	}
</script>

<style scoped lang="scss">
</style>